import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, } from '@angular/common/http';

import { environment } from '../../../environments/environment';

@Injectable()
export class TiposService 
{
    constructor(public http: HttpClient, ) { }

    traeTipos(idProducto: any)
    {
        var headers = new HttpHeaders({            
            'Content-Type':'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem("jwt"),
            'Access-Control-Allow-Methods': 'GET, POST, PUT, PATCH, DELETE',
            'Access-Control-Allow-Origin': '*',
        });

        return this.http.get(`${environment.urlBase}/tipos/productos/${idProducto}`, { headers: headers }).toPromise();
    }
}